<template>
  <section class="main">
    <div class="row">
      <div class="col-12 d-md-block d-none">
        <h3 class="subtitle">Documentos Disponíveis</h3>
        <hr class="simple" />
      </div>
      <div
        class="col-md-3 mt-4"
        v-for="(documento, index) in documentos"
        :key="index"
      >
        <div
          class="card product shadow text-center d-flex justify-content-center"
          v-if="documento"
        >
          <a :href="item.url" target="_blank">
            <div class="card-body">
              <span class="material-icons">get_app</span>
              <p class="card-title">{{ item.titulo }}</p>
              <p class="card-text">{{ item.desc }}</p>
            </div>
          </a>
        </div>
        <div v-else class="card border-0">
          <div class="card absolute border-0">
            <h5 class="d-flex justify-content-center align-items-center">
              <i class="material-icons pr-2 py-3 blue color-blue">info</i> Você
              ainda não possui nenhum chamado ativo
            </h5>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Downloads",
  components: {},
  data() {
    return {
      documentos: [1, 2, 3, 4, 5, 6, 7, 8],
      item: {
        titulo: "Apresentação NFR 2020",
        desc: "documento de apoio NFR",
        url: "https://google.com/document.txt",
      },
      loading: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.form_padrao {
  .form-group.flutuante {
    position: relative;
    input[type="text"],
    input[type="password"],
    input[type="email"],
    input[type="tel"],
    textarea {
      background: white;
    }
  }
  .fit-content {
    max-width: fit-content;
    padding: 0.6rem 1rem !important;
  }
}
@media screen and(max-width: 900px) {
  .fit-content {
    max-width: 100% !important;
  }
}

.card {
  .card-title {
    line-height: 1.5rem;
  }
}
</style>
